<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">

          <div class=" col-lg-12 col-md-12 col-12" v-if="user.role === '3'">
            <div>
              <h2 class="text-white">Bienvenido {{ user.name }}</h2>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-12" v-if="user.role === '1' || user.role === '2'">
            <card :title="stats.sales?.title ?? 'Ventas'" :value="stats.sales?.value ?? '0'"
              :detail="stats.sales?.detail"
              :iconClass="stats.sales?.iconClass ?? 'ni ni-cart'" :iconBackground="stats.sales?.iconBackground ?? 'bg-gradient-success'" directionReverse>
            </card>
          </div>
          <div class="col-lg-3 col-md-6 col-12" v-if="user.role === '1' || user.role === '2'">
            <card :title="stats.purchases?.title ?? 'Compras'" :value="stats.purchases?.value ?? '0'"
              :detail="stats.purchases?.detail"
              :iconClass="stats.purchases?.iconClass ?? 'ni ni-bag-17'" :iconBackground="stats.purchases?.iconBackground ?? 'bg-gradient-info'" directionReverse></card>
          </div>
          <div class="col-lg-3 col-md-6 col-12" v-if="user.role === '1' || user.role === '2'">
            <card :title="stats.month_sales?.title ?? 'Ventas del Mes'" :value="stats.month_sales?.value ?? '0'"
              :detail="stats.month_sales?.detail"
              :iconClass="stats.month_sales?.iconClass ?? 'ni ni-chart-bar-32'" :iconBackground="stats.month_sales?.iconBackground ?? 'bg-gradient-warning'" directionReverse></card>
          </div>

          <div class="col-lg-3 col-md-6 col-12" v-if="user.role === '1'">
            <!-- Siempre mostrar la opción de licencia al admin -->
            <div :class="!isLicenseActiveThisMonth() ? 'pulse-license' : ''">
              <router-link
                :to="{ name: 'Payment' }"
                class="card-link"
              >
                <div class="mb-4 card license-card">
                  <div class="p-3 card-body">
                    <div class="d-flex w-100 align-items-center flex-row-reverse justify-content-between">
                      <div>
                        <div class="text-center icon icon-shape bg-gradient-dark border-radius-2xl">
                          <i class="fa fa-id-card text-lg opacity-10"></i>
                        </div>
                      </div>
                      <div class="numbers">
                        <p class="mb-0 text-sm text-uppercase font-weight-bold">Licencia</p>
                        <h5 class="font-weight-bolder"
                          :class="getLicenseColor()">
                          {{ isLicenseActiveThisMonth() && license && license.status
                            ? (
                                license.status === 'paid' ? 'Pagado' :
                                license.status === 'pending' ? 'Pendiente' :
                                license.status === 'rejected' ? 'Rechazado' :
                                license.status === 'voided' ? 'Anulado' : 'Validando...'
                              )
                            : 'Renovar licencia' }}
                        </h5>
                        <div class="d-flex align-items-center flex-nowrap text-nowrap">
                          <span class="text-sm text-nowrap"
                            :class="getLicenseColor()">
                            {{ license && license.coverage_month
                              ? parseCoverageDate(license.coverage_month)?.toLocaleDateString('es-ES')
                              : 'Sin licencia activa' }}
                          </span>
                          <span
                            v-if="licenseBadgeText()"
                            class="badge badge-sm ms-1 text-nowrap"
                            :class="licenseBadgeClass()"
                          >
                            {{ licenseBadgeText() }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>

        </div>
        <div class="row" v-if="user.role === '1' || user.role === '2'">
          <div class="col-lg-12 mb-lg">
            <!-- line chart -->
            <div class="card">
              <gradient-line-chart title="Ventas y Compras del Año" detail1="Comparativo mensual" detail2="" />
            </div>
          </div>
          <div class="col-lg-5" hidden>
            <carousel />
          </div>
        </div>

        <!-- ---Sección de ventas y compras--- -->
        <div class="row mt-4" v-if="user.role === '1' || user.role === '2'">

          <!-- Métodos de pago -->
          <div class="col-lg-6 mb-lg-0 mb-4">
            <div class="card">
              <div class="p-3 pb-0 card-header">
                <div class="d-flex justify-content-between">
                  <h6 class="mb-2">Métodos de Pago</h6>
                </div>
              </div>

              <div class="table-responsive" style="overflow: auto; max-height: 500px;">
                <table class="table align-items-center">
                  <thead>
                    <tr>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Método</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Transacciones</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value, index) in paymentMethods" :key="index">
                      <td>
                        <div class="px-2 py-1 d-flex align-items-center">
                          <div class="ms-4">
                            <h6 class="mb-0 text-sm">{{ value.method }}</h6>
                          </div>
                        </div>
                      </td>
                      <td class="text-center text-sm">
                        <span class="badge badge-sm bg-gradient-info">{{ value.count }}</span>
                      </td>
                      <td class="text-center text-sm">
                        <span class="font-weight-bold">{{ formatCurrency(value.total) }}</span>
                      </td>
                    </tr>
                    <tr v-if="paymentMethods.length === 0">
                      <td class="text-center" colspan="3">
                        <p>No hay registros</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>


          <!-- Productos más vendidos -->
          <div class="col-lg-6 mb-lg-0 mb-4">
            <div class="card">
              <div class="p-3 pb-0 card-header">
                <div class="d-flex justify-content-between">
                  <h6 class="mb-2">Productos Más Vendidos</h6>
                </div>
              </div>

              <div class="table-responsive" style="overflow: auto; max-height: 500px;">
                <table class="table align-items-center">
                  <thead>
                    <tr>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Producto</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cantidad</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value, index) in topProducts" :key="index">
                      <td>
                        <div class="px-2 py-1 d-flex align-items-center">
                          <div class="ms-4">
                            <h6 class="mb-0 text-sm">{{ value.name }}</h6>
                            <p class="mb-0 text-xs text-secondary">{{ value.ref ?? '—' }}</p>
                          </div>
                        </div>
                      </td>
                      <td class="text-center text-sm">
                        <span class="badge badge-sm bg-gradient-success">{{ value.quantity }}</span>
                      </td>
                      <td class="text-center text-sm">
                        <span class="font-weight-bold">{{ formatCurrency(value.total) }}</span>
                      </td>
                    </tr>
                    <tr v-if="topProducts.length === 0">
                      <td class="text-center" colspan="3">
                        <p>No hay registros</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

        </div>







      </div>
    </div>
  </div>

  <!-- Modal de licencia vencida -->
  <div v-if="showLicenseModal" class="license-modal-overlay" @click.self="dismissLicenseModal">
    <div class="license-modal-box">
      <div class="license-modal-icon">
        <span>!</span>
      </div>
      <h3 class="license-modal-title">¡Tu licencia ha vencido!</h3>
      <p class="license-modal-text">
        Tu licencia venció el {{ licenseExpiredDate }}. Renuévala para seguir disfrutando de todos los beneficios de Mi Stock.
      </p>
      <button class="license-modal-btn" @click="goToPayment">
        <i class="fas fa-credit-card"></i> Renovar ahora
      </button>
      <a href="#" class="license-modal-link" @click.prevent="dismissLicenseModal">Recordar más tarde</a>
    </div>
  </div>
</template>

<style scoped>
.dropdown-toggle::after {
  display: none !important;
}

.license-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.license-modal-box {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  padding: 40px 32px 28px;
  max-width: 420px;
  width: 90%;
  text-align: center;
}

.license-modal-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #ff4757;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.license-modal-icon span {
  color: #fff;
  font-size: 32px;
  font-weight: bold;
}

.license-modal-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 12px;
}

.license-modal-text {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 24px;
}

.license-modal-btn {
  width: 100%;
  padding: 12px 24px;
  border: none;
  border-radius: 50px;
  background: #ff4757;
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.license-modal-btn:hover {
  background: #e83b4a;
}

.license-modal-link {
  display: inline-block;
  margin-top: 16px;
  font-size: 13px;
  color: #999;
  text-decoration: none;
}

.license-modal-link:hover {
  color: #666;
}
</style>
<script>
import Card from "@/examples/Cards/Card.vue";
import GradientLineChart from "@/examples/Charts/GradientLineChart.vue";
import Carousel from "./components/Carousel.vue";

export default {
  name: "dashboard-default",
  data() {
    return {
      searchQuery: '',
      searchQueryUnvalidated: '',
      searchQueryProduction: '',
      searchQueryProductionFinish: '',
      stats: {
        sales: {
          title: "Ventas",
          value: "0",
          percentage: "0",
          iconClass: "ni ni-cart",
          iconBackground: "bg-gradient-success",
          detail: "since yesterday",
        },
        purchases: {
          title: "Compras",
          value: "0",
          percentage: "0",
          iconClass: "ni ni-bag-17",
          iconBackground: "bg-gradient-info",
          detail: "since yesterday",
        },
        users: {
          title: "Usuarios Activos",
          value: "0",
          percentage: "0%",
          iconClass: "ni ni-user-run",
          iconBackground: "bg-gradient-danger",
          detail: "since last week",
        },
        month_sales: {
          title: "Ventas del Mes",
          value: "0",
          iconClass: "ni ni-chart-bar-32",
          iconBackground: "bg-gradient-warning",
          detail: "since last month",
        },
      },
      user: {},
      undelivered: [],
      unvalidated: [],
      production: [],
      productionFinish: [],
      paymentMethods: [],
      topProducts: [],
      license: {
        status: null,
        coverage_month: null
      },
      filterType: 'Todos',
      isFilterOpen: false,
      filterTypeUnvalidated: 'Todos',
      isFilterUnvalidatedOpen: false,
      showLicenseModal: false,
      licenseExpiredDate: '',
    };
  },
  components: {
    Card,
    GradientLineChart,
    Carousel,
  },
  computed: {

    filteredUndelivered() {
      const list = Array.isArray(this.undelivered) ? this.undelivered : [];
      // si no hay texto ni filtro → muestra todo
      if (!this.searchQuery && this.filterType === 'Todos') return list;

      const q = this.searchQuery.toLowerCase();

      return list.filter(value => {
        if (!value) return false;
        /* -------- filtro por tipo -------- */
        const tipo = value.user?.payment === 0 ? 'Mensualidad' : 'Tarea';
        if (this.filterType !== 'Todos' && tipo !== this.filterType) return false;

        /* -------- filtro por búsqueda -------- */
        if (!q) return true;   // solo filtraba por tipo

        const productionId = (value.production?.id ?? '').toString().toLowerCase();
        const userName = (value.user?.name ?? '').toLowerCase();
        return productionId.includes(q) || userName.includes(q);
      });
    },
    filteredUnvalidated() {
      const list = Array.isArray(this.unvalidated) ? this.unvalidated : [];
      // Filtrado combinado de búsqueda y tipo
      const q = this.searchQueryUnvalidated.toLowerCase();

      return list.filter(value => {
        if (!value) return false;
        // Filtro por tipo
        const tipo = value.user?.payment === 0 ? 'Mensualidad' : 'Tarea';
        if (this.filterTypeUnvalidated !== 'Todos' && tipo !== this.filterTypeUnvalidated) return false;

        // Filtro por búsqueda
        if (!q) return true;

        const productionId = (value.production?.id ?? '').toString().toLowerCase();
        const userName = (value.user?.name ?? '').toLowerCase();
        return productionId.includes(q) || userName.includes(q);
      });
    },
    filteredProduction() {
      const list = Array.isArray(this.production) ? this.production : [];
      if (!this.searchQueryProduction) return list;

      return list.filter(value => {
        if (!value) return false;
        const productionId = (value.id ?? '').toString().toLowerCase();
        const productionName = (value.name ?? '').toLowerCase();
        const query = this.searchQueryProduction.toLowerCase();
        return productionId.includes(query) || productionName.includes(query);
      });
    },
    filteredProductionFinish() {
      const list = Array.isArray(this.productionFinish) ? this.productionFinish : [];
      if (!this.searchQueryProductionFinish) return list;

      return list.filter(value => {
        if (!value) return false;
        const productionId = (value.id ?? '').toString().toLowerCase();
        const productionName = (value.name ?? '').toLowerCase();
        const query = this.searchQueryProduction.toLowerCase();
        return productionId.includes(query) || productionName.includes(query);
      });
    }
  },
  methods: {
    formatCurrency(val) {
      const n = parseFloat(val) || 0;
      return '$ ' + n.toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    },
    redirectToProduction(value) {
      this.$router.push({
        name: 'Production Create',
        params: { data: JSON.stringify(value) }
      });
    },
    isValidDate(date) {
      if (!date) {
        return false;
      }
      const parsedDate = new Date(date);
      return !isNaN(parsedDate.getTime());
    },
    async fetchAnalytics() {
      try {
        await this.$store.dispatch('analitycs/getCards');
        const data = this.$store.state.analitycs.cards;
        this.stats = {
          sales: data?.sales || this.stats.sales,
          purchases: data?.purchases || this.stats.purchases,
          users: data?.users || this.stats.users,
          month_sales: data?.month_sales || this.stats.month_sales,
        };
        this.paymentMethods = Array.isArray(data?.payment_methods) ? data.payment_methods : [];
        this.topProducts = Array.isArray(data?.top_products) ? data.top_products : [];
      } catch (e) {
        // Si el endpoint falla (404/500), no romper el Dashboard
        this.stats.sales.value = "0";
        this.stats.purchases.value = "0";
        this.stats.users.value = "0";
        this.stats.month_sales.value = "0";
        this.paymentMethods = [];
        this.topProducts = [];
      }
    },
    async fetchUndelivered() {
      try {
        let datos = await this.$store.dispatch('analitycs/getUndelivered');
        const payload = datos?.data;
        const list = Array.isArray(payload) ? payload : (Array.isArray(payload?.data) ? payload.data : []);
        this.undelivered = list;
      } catch (e) {
        this.undelivered = [];
      }
    },
    async fetchUnvalidated() {
      try {
        let datos = await this.$store.dispatch('analitycs/getUnvalidate');
        const payload = datos?.data;
        const list = Array.isArray(payload) ? payload : (Array.isArray(payload?.data) ? payload.data : []);
        this.unvalidated = list;
      } catch (e) {
        this.unvalidated = [];
      }
    },
    async fetchProduction() {
      try {
        let datos = await this.$store.dispatch('analitycs/getProduction');
        const payload = datos?.data;
        const list = Array.isArray(payload) ? payload : (Array.isArray(payload?.data) ? payload.data : []);
        this.production = list;
      } catch (e) {
        this.production = [];
      }
    },
    async fetchProductionFinish() {
      try {
        let datos = await this.$store.dispatch('analitycs/getProductionFinish');
        const payload = datos?.data;
        const list = Array.isArray(payload) ? payload : (Array.isArray(payload?.data) ? payload.data : []);
        this.productionFinish = list;
      } catch (e) {
        this.productionFinish = [];
      }
    },
    async fetchLicense() {
      try {
        const lic = await this.$store.dispatch('payments/get');
        this.license = lic ?? null;
        this.checkLicenseExpired();
      } catch (e) {
        this.license = null;
      }
    },
    parseCoverageDate(dateStr) {
      if (!dateStr) return null;
      const dateOnly = String(dateStr).split('T')[0];
      const d = new Date(dateOnly + 'T00:00:00');
      return isNaN(d.getTime()) ? null : d;
    },
    checkLicenseExpired() {
      if (!this.license || !this.license.coverage_month) return;
      const coverage = this.parseCoverageDate(this.license.coverage_month);
      if (!coverage) return;
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      const diffTime = coverage.getTime() - now.getTime();
      const daysRemaining = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (daysRemaining < 0) {
        this.licenseExpiredDate = coverage.toLocaleDateString('es-ES');
        this.showLicenseModal = true;
      }
    },
    goToPayment() {
      this.showLicenseModal = false;
      this.$router.push({ name: 'Payment' });
    },
    dismissLicenseModal() {
      this.showLicenseModal = false;
    },
    isLicenseActiveThisMonth() {
      if (!this.license || !this.license.status || !this.license.coverage_month) {
        return false;
      }
      try {
        const coverage = this.parseCoverageDate(this.license.coverage_month);
        if (!coverage) return false;
        const now = new Date();
        now.setHours(0, 0, 0, 0);
        // Consideramos "pago activo" si está pagado y la fecha de cobertura es hoy o una fecha futura
        return this.license.status == 'paid' && coverage >= now;
      } catch (e) {
        return false;
      }
    },
    getLicenseDaysRemaining() {
      if (!this.license || !this.license.coverage_month) return null;
      const coverage = this.parseCoverageDate(this.license.coverage_month);
      if (!coverage) return null;
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      const diffTime = coverage.getTime() - now.getTime();
      return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    },
    licenseBadgeClass() {
      const days = this.getLicenseDaysRemaining();
      if (days === null) return '';
      if (days >= 0 && days <= 3) return 'bg-gradient-warning';
      return '';
    },
    licenseBadgeText() {
      const days = this.getLicenseDaysRemaining();
      if (days === null) return '';
      if (days >= 0 && days <= 3) {
        if (days === 0) return 'Hoy vence';
        return 'en ' + days + ' día' + (days !== 1 ? 's' : '');
      }
      return '';
    },
    getLicenseColor() {
      const days = this.getLicenseDaysRemaining();
      if (days === null) return 'text-danger';
      if (days < 0) return 'text-danger';
      if (days <= 3) return 'text-warning';
      return 'text-success';
    },
    getStatusColor(status) {
      if (!status) return 'text-secondary';
      switch (status) {
        case 'paid':
          return 'text-success';  // Color verde para "Pagado"
        case 'pending':
          return 'text-warning';  // Color amarillo para "Pendiente"
        case 'rejected':
          return 'text-danger';   // Color rojo para "Rechazado"
        case 'voided':
          return 'text-muted';    // Color gris para "Anulado"
        default:
          return 'text-secondary'; // Color por defecto
      }
    },
    /* ---------- filtros ---------- */
    toggleFilter() {
      this.isFilterOpen = !this.isFilterOpen;
      this.isFilterUnvalidatedOpen = false;
    },
    toggleUnvalidatedFilter() {
      this.isFilterUnvalidatedOpen = !this.isFilterUnvalidatedOpen;
      this.isFilterOpen = false;
    },
    /* seleccionar opción y cerrar */
    setFilter(tipo) {
      this.filterType = tipo;
      this.isFilterOpen = false;
    },
    setFilterUnvalidated(tipo) {
      this.filterTypeUnvalidated = tipo;
      this.isFilterUnvalidatedOpen = false;
    },
    /* click fuera */
    onClickOutside(e) {
      if (
        this.isFilterOpen &&
        this.$refs.undeliveredDropdown &&
        !this.$refs.undeliveredDropdown.contains(e.target)
      ) {
        this.isFilterOpen = false;
      }
      if (
        this.isFilterUnvalidatedOpen &&
        this.$refs.unvalidatedDropdown &&
        !this.$refs.unvalidatedDropdown.contains(e.target)
      ) {
        this.isFilterUnvalidatedOpen = false;
      }
    },

  },
  mounted() {
    document.addEventListener("click", this.onClickOutside);


    let user = JSON.parse(localStorage.getItem('user'));
    this.user = user;

    // Redirigir operadores a su dashboard
    if (user && user.role === '3') {
      this.$router.push({ name: 'Operador Dashboard' });
      return;
    }

    if (user.role === '1' || user.role === '2') {
      this.fetchAnalytics();
      this.fetchUndelivered();
      this.fetchUnvalidated();
      this.fetchLicense();
    }


  },
  beforeUnmount() {
    document.removeEventListener("click", this.onClickOutside);
  },
};
</script>

<style scoped>
.pulse-license {
  display: inline-block;
  /* Animación cada 5 segundos */
  animation: license-bounce 5s ease-in-out infinite;
}

@keyframes license-bounce {
  0%   { transform: translateY(0) scale(1); }
  5%   { transform: translateY(-8px) scale(1.03); }
  10%  { transform: translateY(0) scale(1); }
  15%  { transform: translateY(-4px) scale(1.02); }
  20%  { transform: translateY(0) scale(1); }
  100% { transform: translateY(0) scale(1); }
}
</style>
